import React, { forwardRef, useState } from "react";
import { Table as AntTable, Space } from "antd";
import TableProvider, {
  useTableContext,
} from "src/components/Table/TableProvider";
import { useFormContext } from "../Form";
import { FilterOutlined } from "@ant-design/icons";
import Button from "../Button/Button";
import Dialog from "../Dialog/Dialog";

const Table = forwardRef(
  (
    {
      columns,
      leftMoreFilters,
      rightMoreFilters,
      filterInputs,
      actions,
      ...props
    },
    ref
  ) => {
    return (
      <TableProvider ref={ref} {...props}>
        <TableComponent
          columns={columns}
          leftMoreFilters={leftMoreFilters}
          rightMoreFilters={rightMoreFilters}
          filterInputs={filterInputs}
          actions={actions}
        />
      </TableProvider>
    );
  }
);

const TableComponent = ({
  columns,
  leftMoreFilters = [],
  rightMoreFilters = [],
  filterInputs = [],
  actions = [],
}) => {
  const { data, metadata, fetchData, loading } = useTableContext();
  const { reset, defaultValues, setValue, getValues, formState } =
    useFormContext();
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  // Reset filters
  const handleResetFilters = () => {
    reset(defaultValues);
    fetchData();
  };

  return (
    <>
      <div className="w-full">
        <div className="p-4 flex flex-wrap items-center gap-4">
          <Space>{actions}</Space>

          {/* Filter section */}
          <Space className="ml-auto">
            {[...leftMoreFilters, ...rightMoreFilters, ...filterInputs].length >
              0 && (
              <div>
                <Button onClick={handleResetFilters}>Reset filters</Button>
                <Button onClick={fetchData}>Apply filters</Button>
              </div>
            )}

            {(leftMoreFilters.length > 0 || rightMoreFilters.length > 0) && (
              <Button
                icon={<FilterOutlined />}
                onClick={() => setShowMoreFilters(true)}
              >
                More
              </Button>
            )}
            {filterInputs.map((input) => {
              return React.cloneElement(input, {
                key: input.props.name,
                style: { minWidth: "100px" },
                onChange: (e) => {
                  if (["FormDatePicker", "FormSelect"].includes(input.type.name)) {
                    setValue(input.props.name, e);
                    fetchData();
                  }
                },
                onBlur: (e) => {
                  if (["FormText"].includes(input.type.name)) {
                    fetchData();
                  }
                },
              });
            })}
          </Space>
        </div>

        <Dialog
          open={showMoreFilters}
          onClose={() => {
            fetchData();
            setShowMoreFilters(false);
          }}
          title="Additional Filters"
          width={600}
        >
          <div className="grid grid-cols-2 gap-4">
            <div className="grid grid-cols-1 gap-4">
              {leftMoreFilters.map((input) => {
                return React.cloneElement(input, {
                  key: input.props.name,
                });
              })}
            </div>
            <div className="grid grid-cols-1 gap-4">
              {rightMoreFilters.map((input) => {
                return React.cloneElement(input, {
                  key: input.props.name,
                });
              })}
            </div>
          </div>
        </Dialog>
        <AntTable
          columns={columns}
          dataSource={data}
          rowKey="id"
          loading={loading}
          pagination={{
            page: getValues("page"),
            current: metadata.currentPage,
            pageSize: metadata.limit,
            total: metadata.total,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} items`,
          }}
          onChange={(page) => {
            setValue("page", page.current);
            setValue("limit", page.pageSize);
            fetchData();
          }}
          scroll={{ x: "max-content" }}
        />
      </div>
    </>
  );
};

export default Table;
